import React, { useMemo } from 'react';

import { PROMO_CODES } from '../../constants/promoCodes';
import { formatRecurringPeriodString } from '../paymentComponents/PaymentUtils';


function DisplayPayInfo(props) {
  const { activeCampaign, isPromoPage, program } = props;

  const {
    amount,
    details: {
      recurringAmount,
      recurringPeriod,
      recurringPeriodType,
      isTrial,
      max,
    },
    currency: { symbol },
  } = program;
  const fee = program.details.fee || 0;

  const correctAmount = useMemo(() => {
    if (recurringAmount) {
      return recurringAmount;
    }

    const decimalPoint = 10000;

    const convertedAmount = amount * decimalPoint;
    const convertedFee = fee * decimalPoint;

    const finalAmount = parseInt(convertedAmount - convertedFee, 10);

    return finalAmount / decimalPoint;
  }, [recurringAmount, amount, fee]);

  const initialAmountToPay = useMemo(() =>
    amount - fee || recurringAmount || correctAmount, [amount, correctAmount, fee, recurringAmount]);

  const paymentPeriod = useMemo(() => {
    if ((recurringPeriod === 12) && (recurringPeriodType?.toLowerCase() === 'month')) {
      return 'Yearly';
    }

    return `${recurringPeriodType?.toLowerCase()}ly`;
  }, [recurringPeriod, recurringPeriodType]);

  if (
    (activeCampaign?.affiliateCode?.includes('NNLIVEMR') || (isPromoPage &&
      activeCampaign?.affiliateCode === PROMO_CODES.ASNAW22))
  ) {
    return null;
  }

  if (isTrial) {
    return (
      <small className="pay-info">
        Free initially. Rebills {paymentPeriod} at {symbol}
        {recurringAmount}
      </small>
    );
  }
  if ((amount && recurringPeriod) || (recurringAmount && (amount !== recurringAmount))) {

    return (
      <small className="pay-info">
        Billed {symbol}
        {initialAmountToPay} first {recurringPeriod > 1 ? recurringPeriod : ''}&nbsp;
        {recurringPeriod > 1 ? `${recurringPeriodType?.toLowerCase()}s` : recurringPeriodType?.toLowerCase()}
        . Rebills&nbsp;
        {formatRecurringPeriodString(
          recurringPeriod,
          recurringPeriodType?.toLowerCase()
        )}&nbsp;at {symbol}
        {correctAmount}
      </small>
    );
  }


  return (
    <small className="pay-info">
      {`Billed as one payment of ${program.currency.symbol}${correctAmount}`}
    </small>
  );
}

export default DisplayPayInfo;
